<script lang="ts">
  import { setContext, type Snippet } from 'svelte'

  type Props = {
    children: Snippet
  }

  const { children }: Props = $props()

  const dropdownContextState = $state<DropdownContext>({
    isOpen: false,
  })
  setContext('dropdownContext', dropdownContextState)
</script>

{@render children()}
